define('views/components/lead/leads',['require','views/base/collection_view','views/components/lead/lead_list','text!templates/components/lead/leads.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/lead/lead_list');

    var temp = require("text!templates/components/lead/leads.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container lead-grid-container',

        afterRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

